import styled from "styled-components";
export const LayoutContainer = styled.div`
  .main-content {
    min-height: 70vh;
  }
`;
